module.exports = __webpack_public_path__ + "img/sensor_1_1.8dd3cf27.png";